module.exports = __webpack_public_path__ + "img/beer_id-40.eba8f2f6.png";